import { useApiQuery } from '../use-api.js';
import { MetricCard } from '../components/MetricCard.js';

interface ScorecardMetric {
  name: string;
  baseline: number | null;
  current_30d: number | null;
  delta: number | null;
}

interface ScorecardResponse {
  org: string;
  metrics: ScorecardMetric[];
}

export function VelocityScorecard() {
  const { data, isLoading, error } = useApiQuery<ScorecardResponse>(
    ['scorecard', 'rewindio'],
    '/api/scorecard?org=rewindio'
  );

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Velocity Scorecard</h2>

      {isLoading && <p className="text-sm text-gray-500">Loading…</p>}
      {error && <p className="text-sm text-red-600">Error: {String(error)}</p>}

      {data && (
        <>
          <p className="text-sm text-gray-500 mb-4">Org: {data.org}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {(data.metrics ?? []).map(m => (
              <MetricCard
                key={m.name}
                name={m.name}
                baseline={m.baseline}
                current30d={m.current_30d}
                delta={m.delta}
              />
            ))}
            {(data.metrics ?? []).length === 0 && (
              <p className="text-sm text-gray-400 col-span-full">No metrics available yet.</p>
            )}
          </div>
          <p className="text-xs text-gray-400 mt-6">
            Note: 90-day Recharts trendlines deferred to v2.
          </p>
        </>
      )}
    </div>
  );
}
